module.exports = __webpack_public_path__ + "media/images/logo-eef304ad161f365bb61540d5fee7401c.png";